/* eslint-disable */
import { Button, Tag, Dropdown, Modal, message,Tooltip } from "antd";
import React, { useEffect, useState, useRef } from "react";
import "./index.scss";
import {
  MenuOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  SolutionOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { CustomTable, CustomTableExtend } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import { useNavigate } from "react-router-dom";
import ContractorAddModal from "./AddModal";
import ContractorUpdateModal from "./UpdateModal";
import ContractorLaunchModal from "./LaunchModal";
import ContractorPreviewModal from './PreviewModal'
import { render } from "@testing-library/react";
export default function Contractor() {
  const initTableHead = {
    prop: undefined,
    street: undefined,
    contractor: undefined,
    projectIdStr: undefined,
    contractedAmount: undefined,
    paid: undefined,
    requested: undefined,
    co: undefined,
    remaining: undefined,
    startCreateDate: undefined,
    endCreateDate: undefined,
    startCommenceDate: undefined,
    endCommenceDate: undefined,
    startExpectedCompleteTimeDate: undefined,
    endExpectedCompleteTimeDate: undefined,
    startContractDate: undefined,
    endContractDate: undefined,
    status: undefined,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };
  const typeList = [
    { value: "", label: "All" },
    { value: "carousel", label: "Carousel" },
    { value: "text", label: "Text" },
  ];
  const statusList = [
    { value: "", label: "All" },
    { value: "1", label: "Launch" },
    { value: "0", label: "Remove" },
  ];

  const navigate = useNavigate();

  // const handleMenuClick = (e, record) => {
  //   switch (e.key) {
  //     case 'edit':
  //       navigate(`/JobRequests/MajorProjectEdit?id=${record.id}&projectName=${record.contractor}`)
  //       break;

  //     default:
  //       break;
  //   }
  // }

  const handleMenuClick = async (e, record) => {
    console.log("e", e);
    if (e.key === "launch") {
      launchModalRef.current?.openModal(record);
    }

    if (e.key === "update") {
      console.log("update", updateModalRef);
      updateModalRef.current?.openModal(record);
    }
    if (e.key === "delete") {
      console.log(record);
      Modal.confirm({
        title: "Delete contract",
        icon: <ExclamationCircleOutlined />,
        content: `Are you sure you want to delete the selected data?`,
        okText: "Sure",
        cancelText: "Cancel",
        onOk: async () => {
          const params = {
            id: record.id,
          };
          const response = await http.get(api.getAppDelete, { params });

          console.log(response);
          if (response?.code === "1") {
            message.success("Deleted successfully");
            getTableListFn();
          } else {
            message.error(response.msg);
          }
        },
        onCancel() {
          console.log("Cancel");
        },
        style: {
          top: "40%",
        },
      });
    }
        if (e.key === "remove") {
      console.log(record);
      Modal.confirm({
        title: "Confirm Status Change",
        icon: <ExclamationCircleOutlined />,
        content: `Are you sure you want to change the status to Remove?`,
        okText: "Sure",
        cancelText: "Cancel",
        onOk: async () => {
          const params = {
            ids: record.id,
          };
          const response = await http.get(api.getUpdateRemove, { params });

          console.log(response);
          if (response?.code === "1") {
            message.success("Remove successfully");
            getTableListFn();
          } else {
            message.error("Remove failed");
          }
        },
        onCancel() {
          console.log("Cancel");
        },
        style: {
          top: "40%",
        },
      });
    }

  };

  const initColumns = [
    //     {
    //   title: "Action",
    //   key: "action",
    //   dataIndex: "propId",
    //   hidden: false,
    //   align: "center",
    //   width: 80,
    //   render: (text, record) => (
    //     (
    //       commonFn.btnAuthorityFlag('Launch') ||
    //       commonFn.btnAuthorityFlag('Edit') ||
    //       commonFn.btnAuthorityFlag('Delete')
    //     ) && (<Dropdown
    //         menu={{
    //           items: [
    //             commonFn.btnAuthorityFlag('Launch') && {
    //               key: "reset",
    //               icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
    //               label: <div>Password Reset</div>,
    //             },
    //             commonFn.btnAuthorityFlag('Edit') && {
    //               key: "update",
    //               icon: <SolutionOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
    //               label: <div>View/Edit Account</div>,
    //             },
    //             commonFn.btnAuthorityFlag('Delete') && {
    //               key: "updateRole",
    //               icon: <ToolOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
    //               label: <div>View/Edit Role</div>,
    //             },
    //           ],
    //           onClick: (e) => handleMenuClick(e, record),
    //         }}
    //         trigger={["click"]}
    //       >
    //         <MenuOutlined
    //           style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
    //         />
    //       </Dropdown>)
    //   ),
    // },
    {
      title: "Action",
      key: "action",
      dataIndex: "propId",
      hidden: false,
      align: "center",
      width: 80,
      render: (text, record) => (
         (
           commonFn.btnAuthorityFlag('RemoveLaunch') ||
           commonFn.btnAuthorityFlag('Update') ||
           commonFn.btnAuthorityFlag('Delete')
         ) && (<Dropdown
          menu={{
            items: [
              commonFn.btnAuthorityFlag('RemoveLaunch') && {
                key: record.status === 1 ? "remove" : "launch",
                icon: (
                  <EditOutlined
                    style={{ color: "#00c0ef", fontSize: "17px" }}
                  />
                ),
                label: <div>{record.status === 1 ? "Remove" : "Launch"}</div>,
              },
              commonFn.btnAuthorityFlag('Update') && {
                key: "update",
                icon: (
                  <SolutionOutlined
                    style={{ color: "#00c0ef", fontSize: "17px" }}
                  />
                ),
                label: <div>Update</div>,
              },
              commonFn.btnAuthorityFlag('Delete') && {
                key: "delete",
                icon: (
                  <ToolOutlined
                    style={{ color: "#00c0ef", fontSize: "17px" }}
                  />
                ),
                label: <div>Delete</div>,
              },
            ],
            onClick: (e) => handleMenuClick(e, record),
          }}
          trigger={["click"]}
        >
          <MenuOutlined
            style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
          />
        </Dropdown>)
      ),
    },
    {
      title: "Title",
      dataIndex: "title",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "title"),
    },

      {
    title: 'Content',
    dataIndex: 'content',
    titleType: 'Input',
    width: 180,
    isSorter: true,
    sortterMultiple: 3,
    onChange: e => tableFilterFn(e, 'content'),
    render: text => (
      <Tooltip title={text}>
        <div
          style={{
            whiteSpace: 'normal',   
            wordBreak: 'break-word',
            overflow: 'hidden',
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
    // {
    //   title: "Source Remark",
    //   dataIndex: "sourceRemark",
    //   titleType: "Input",
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   isTooltipFlag: true,
    //   onChange: (e) => tableFilterFn(e, "sourceRemark"),
    // },
          {
    title: 'Source Remark',
    dataIndex: 'sourceRemark',
    titleType: 'Input',
    width: 180,
    isSorter: true,
    sortterMultiple: 3,
    onChange: e => tableFilterFn(e, 'sourceRemark'),
    render: text => (
      <Tooltip title={text}>
        <div
          style={{
            whiteSpace: 'normal',   
            wordBreak: 'break-word',
            overflow: 'hidden',
          }}
        >
          {text}
        </div>
      </Tooltip>
    ),
  },
    {
      title: "status",
      dataIndex: "status",
      titleType: "Select",
      selectOptions: statusList,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "status", "Select"),
      render: (text) => (text === 1 ? "Launch" : text === 0 ? "Remove" : text),
    },
    {
      title: "Type",
      dataIndex: "type",
      titleType: "Select",
      isSorter: true,
      selectOptions: typeList,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "type", "Select"),
    },
    {
      title: "Url",
      dataIndex: "url",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "url"),
      render: (text) => {
        if (!text) return null;

        const handleClick = (e) => {
          e.preventDefault();
          Modal.confirm({
            title: "Notice",
            content: `Do you want to open this external link?\n${text}`,
            okText: "Open",
            cancelText: "Cancel",
            onOk: () => {
              window.open(text, "_blank");
            },
          });
        };

        return (
          <a href={text} onClick={handleClick}>
            {text}
          </a>
        );
      },
    },
    {
      title: "Create Time",
      dataIndex: "createTime",
      titleType: "",
      onChange: (e) =>
        tableFilterFn(
          e,
          ["startExpectedCompleteTimeDate", "endExpectedCompleteTimeDate"],
          "RangePicker"
        ),
          render: (text) => (text ? moment(text).format("MM/DD/YYYY") : ""),
    },
    {
      title: "Update Time",
      dataIndex: "updateTime",
      titleType: "",
      onChange: (e) =>
        tableFilterFn(
          e,
          ["startCommenceDate", "endCommenceDate"],
          "RangePicker"
        ),
          render: (text) => (text ? moment(text).format("MM/DD/YYYY") : ""),
    },
  ];

  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      // managerId: Number(localStorage.getItem("accountId")),
      ...tableHead,
    };
    const response = await http.get(api.AppAdvertisingShow, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
    }));
    setTableList(list);
    setContractRowKey([]);
    setContractApproveDisable(false);
    setContractDeleteDisable(false);
    setContractEditDisable(false);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
  };

  const handleRoleUpdateSuccess = () => {
    getTableListFn(pagination.current, pagination.pageSize);
  };

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 25);
  }, [refreshKey]);

  const contractRef = useRef(null);
  const updateModalRef = useRef(null);
  const launchModalRef = useRef(null);
  const previewModalRef = useRef (null);
  const [contractRowKey, setContractRowKey] = useState([]);
   const [contractApproveDisable, setContractApproveDisable] = useState(false);
  const [contractDeleteDisable, setContractDeleteDisable] = useState(false);
  const [contractEditDisable, setContractEditDisable] = useState(false);

  const btnListDocFn = ({ btnList }) => {
    return (
      <span className="btnList">
        {btnList.map((item) => (
          <commonFn.BtnAuthorityFn authKey={item.authKey}>
            <Button
              className="btnItem"
              onClick={() => btnListClickFn(item)}
              icon={
                <img
                  className="img"
                  src={require(`@/assets/images/contractor/${item.icon}.png`)}
                  alt=""
                />
              }
              disabled={item.disabled}
            >
              {item.label}
            </Button>
          </commonFn.BtnAuthorityFn>
        ))}
      </span>
    );
  };

const btnListClickFn = (item) => {
  const { type, icon, modalName } = item;

  const contractFlag =
    [
      "contractApprove",
      "contractView",
      "contractEdit",
      "contractDelete",
    ].includes(type) && !contractRowKey.length;

  if (contractFlag) {
    message.warning("Please select at least one item.");
    return;
  }

  switch (type) {
    case "contractAdd":
    case "contractApprove":
    case "contractView":
    case "contractEdit":
      contractRef.current.openModal(icon, modalName);
      break;

    case "updatePreview":
      previewModalRef.current.openModal(icon, modalName);
      break;

    case "contractDelete":
      secondConfirmFn(type);
      break;

    default:
      break;
  }
};

  const [selectStatus, setSelectStatus] = useState(0);

  const contractBtnList = (
    contractApproveDisable = false,
    contractEditDisable = false,
    contractDeleteDisable = false
  ) => {
    return [
      {
        label: "New",
        icon: "add",
        type: "contractAdd",
        authKey: "New",
        modalName: "New Major Project",
      },
      {
        label: "Preview",
        icon: "approve",
        type: "updatePreview",
        modalName: "Launch",
        authKey: "Preview",
      },
      // {
      //   label: "View",
      //   icon: "view",
      //   type: "contractView",
      //   modalName: "View Major Project",
      //   authKey: "View",
      // },
      // {
      //   label: "Edit",
      //   icon: "edit",
      //   type: "contractEdit",
      //   modalName: "Edit Major Project",
      //   authKey: "Edit",
      //   disabled: contractEditDisable,
      // },
      // {
      //   label: "Delete",
      //   icon: "delete",
      //   type: "contractDelete",
      //   authKey: "Delete",
      //   disabled: contractDeleteDisable,
      // },
    ];
  };

  const secondConfirmFn = () => {
    const statusMatch = {
      2: 7,
      3: 5,
    };
    Modal.confirm({
      title: "Delete contract",
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to delete the selected data?`,
      okText: "Sure",
      cancelText: "Cancel",
      onOk: async () => {
        const response = await http.post(api.delContract, {
          id: contractRowKey[0],
          approveType: statusMatch[selectStatus],
        });
        if (response?.code === "1") {
          message.success("Deleted successfully");
          getTableListFn();
        } else {
          setTimeout(() => {
            commonFn.modalFailedFn(response);
          }, 500);
        }
      },
      onCancel() {
        console.log("Cancel");
      },
      style: {
        top: "40%",
      },
    });
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag("Download") && "download"]}
      >
        {btnListDocFn({
          btnList: contractBtnList(
            contractApproveDisable,
            contractEditDisable,
            contractDeleteDisable
          ),
          borderFlag: true,
        })}
      </CustomTableExtend>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="380px"
        rowKey={"id"}
        tableCss="maintenanceTable"
      />

      {/* 新增 */}
      <ContractorAddModal
        ref={contractRef}
        onSuccess={handleRoleUpdateSuccess}
      />
      {/* 修改 */}
      <ContractorUpdateModal
        ref={updateModalRef}
        onSuccess={handleRoleUpdateSuccess}
      />

      {/* 上架 */}
      <ContractorLaunchModal
        ref={launchModalRef}
        onSuccess={handleRoleUpdateSuccess}
      />
      
      {/* 预览 */}
       <ContractorPreviewModal  ref={previewModalRef}
        onSuccess={handleRoleUpdateSuccess}/>
    </div>
  );
}
